export const QUESTIONNAIRE_URL = "https://enquetes.univ-rouen.fr/444836?lang=fr"